export function onTurboStreamConnected(streamName, callback) {
  const streamSource = document.querySelector(`turbo-cable-stream-source[data-turbo-stream-name-value="${streamName}"]`);

  if (!streamSource) {
    console.warn(`Stream ${streamName} not found.`);
    return;
  }

  if (streamSource.hasAttribute('connected')) {
    callback();
  } else {
    streamSource.addEventListener(`${streamName}:connected`, callback, { once: true });
  }
}

